__turbopack_context__.v({
  "brand": "Tag-module-scss-module__xzy0SG__brand",
  "is-small": "Tag-module-scss-module__xzy0SG__is-small",
  "light-blue": "Tag-module-scss-module__xzy0SG__light-blue",
  "orange": "Tag-module-scss-module__xzy0SG__orange",
  "pink": "Tag-module-scss-module__xzy0SG__pink",
  "purple": "Tag-module-scss-module__xzy0SG__purple",
  "tag": "Tag-module-scss-module__xzy0SG__tag",
  "with-background": "Tag-module-scss-module__xzy0SG__with-background",
  "yellow": "Tag-module-scss-module__xzy0SG__yellow",
});
